import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Heading } from '@shieldpay/bumblebee/heading';
import { Column } from '@shieldpay/bumblebee/layout';
import { Text } from '@shieldpay/bumblebee/text';

const ErrorHeading = ({ children }: { children: ReactNode }) => (
  <Heading align="left">{children}</Heading>
);

const Error = ({ children }: { children: ReactNode }) => (
  <Column alignContent={{ x: 'left', y: 'center' }} spacing="basePos3">
    {children}
  </Column>
);

Error.Heading = ErrorHeading;

const ErrorDescription = ({ id }: { id: string }) => (
  <FormattedMessage
    id={id}
    values={{
      p: (values) => (
        <Text
          // explicit key is a workaround for react-intl and react 19
          // https://github.com/formatjs/formatjs/issues/4782
          key={values.toString()}
          paragraph
          align="left"
        >
          {values}
        </Text>
      ),
    }}
  />
);

Error.Description = ErrorDescription;

export { Error };
